import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneValid = (phone: string): boolean => {
    if (typeof phone !== 'string' || !phone.trim()) {
        return false;
    }

    if (phone.trim().length < 10) {
        return false;
    }
    try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone));
    } catch (error) {
        console.error("Phone validation error:", error);
        return false;
    }
};

export default isPhoneValid;
